<template>
    <div class="app container">
        <!-- 地图 -->
        <div id="container" class="case-map"></div>

        <div class="header-box">
            <!--                                            <div @click="gouloadcase" class="icon-add">发布案例</div>-->
            <div class="tab-nav-wrap">
                <div class="search-item" @click="getShow">
                    <img :src="require('@/assets/images/case/map/search-icon.png')" class="search-icon" alt="">
                    <span>搜索案例</span>
                </div>
                <div class="tab-nav-item" v-for="(item, index) in searchConf.tab" :key="item.code">
                    <p :class="{ active: item.select }" @click="fastSearch(index,item)">
                        {{ item.name }}
                    </p>
                </div>
                <div class="tab-nav-item">
                    <p @click="toAntMap">冷暖风水</p>
                </div>
                <div class="tab-nav-item" v-for="(item, index) in searchConf.brand" :key="item.code">
                    <p :class="{ active: item.select }" @click="fastSearch(index,item)">
                        {{ item.name }}
                    </p>
                </div>
                <!--                <div class="tab-nav-item tab-nav-item-last">-->
                <!--                    <p @click="toCommercial">商用净水</p>-->
                <!--                </div>-->
            </div>

            <div class="search" v-show="bShow">

                <div class="search-box-wrap">
                    <div class="leads-box">
                        <div class="input-box goods-wrap">
                            <label>产品型号</label>
                            <div class="goods-content">
                                <input type="text" placeholder="输入产品型号搜索" @input="inputChange" @focus='focusing' @blur="blue" v-model="proType" placeholder-class="place" />
                                <div class="content" v-show="isShowSelectType">
                                    <!-- 有数据 -->
                                    <van-list class="data-content" v-if="arrGoods.length" @load="onLoadType" offset="0" :loading="isLoading" :finished="isFinish" finished-text="没有更多了">
                                        <div class="item" v-for="item in arrGoods" @mousedown="selectGoodName(item.goods_name)" :key="item.id+'m'">
                                            {{ item.goods_name }}
                                        </div>
                                    </van-list>
                                    <!-- 无数据 -->
                                    <div class="error" v-else>暂无数据</div>
                                </div>
                            </div>
                        </div>
                        <div class="input-box">
                            <label>小区名称</label>
                            <input type="text" placeholder="输入小区名称或关键字" v-model="rqname" placeholder-class="place" />
                        </div>
                        <div class="tag-box">
                            <label>案例类型</label>
                            <div class="list">
                                <template v-if="!allCase">
                                    <p :class="{ 'active-tag': item.select }" class="tag" @click="setSearchConfKey('topic_type', index)" v-for="(item, index) in searchConf.topic_type" :key="index">
                                        {{ item.name }}
                                    </p>
                                </template>
                                <p :class="{ 'active-tag': allCase }" class="tag" @click="selectAllCase()">
                                    全部案例
                                </p>
                            </div>
                        </div>

                        <div class="tag-box">
                            <label>产品品类</label>
                            <div class="list">
                                <template v-if="!allCategory">
                                    <p :class="{ 'active-tag': item.select }" @click="setSearchConfKey('cate', index)" class="tag" v-for="(item, index) in searchConf.cate" :key="index" v-show="item.type==0">
                                        {{ item.name }}
                                    </p>
                                </template>
                                <p :class="{ 'active-tag': allCategory }" class="tag" @click="selectAllCategory">不限</p>
                            </div>
                        </div>

                    </div>
                    <div class="footer-btn-wrap">
                        <div class="action-button" @click.stop="bShow = false">取消</div>
                        <div class="action-button confirm-action-button" @click.stop="getseash(true)">确定搜索</div>
                    </div>
                </div>
                <div class="close " @click="getShow"></div>
            </div>
        </div>
        <!-- 案例列表	 -->
        <transition name="collapse-list">
            <case-list :isEmpty="isEmpty" :arrCaseList="arrCaseList" :sCity="sCity" :sProvince="sProvince" :nLongitude="nLongitude" :nLatitude="nLatitude" @close-case-list="closeCaseList" @hidenList="(wellEvaVisible=true) && (isCaseListShow=false)" v-if="isCaseListShow" />
        </transition>

        <!-- 遮罩层 -->
        <div class="mask" @click="isSearchShow = false" v-show="isSearchShow"></div>

        <awesome-picker ref="picker" :anchor="anchor" :data="address" :colorConfirm="sColor" :colorCancel="sColor" swipeTime:500 @confirm="handlePickerConfirm" v-if="bPicker"></awesome-picker>

        <!-- 侧边栏 -->
        <div class="reposition side-bar" @click="reposition()">
            <img :src="require('@/assets/images/case/map/loaction-icon.png')" alt="" />
        </div>
        <div class="bus" @click="toSpecial">
            <span>致总裁信</span>
            <img src="@/assets/images/household/green-icon.png" mode="widthFix" />
        </div>

        <div class="address-show side-bar">
            <img :src="require('@/assets/images/case/map/address-icon.png')" alt="" class="address-icon">
            <p>{{ sCity ? sCity : "未知" }}</p>
        </div>

        <div class="list-model side-bar" @click="gocasemap">
            <img :src="require('@/assets/images/case/map/swith-model-icon.png')" alt="" />
            <p>列表<br>模式</p>
        </div>
        <div class="baidu_click">
            <div class="baidu_item green" @click="getClickWindom(1)">
                <img src="@/assets/images/case/home_icon.png" alt="">
                商城咨询
            </div>
            <div class="baidu_item wilith" @click="getClickWindom(2)">
                <img src="@/assets/images/case/kefu_icon.png" alt="">
                免费设计<br />报名
            </div>
        </div>

        <!--     好评案例列表    -->
        <transition name="collapse-list">
            <div v-if="wellEvaVisible" class="evaluate-well-wrap" :class="{'open-eva-list':openEvaList}">
                <div class="evaluate-item-container" v-for="item in wellEvaCaseList" :key="item.id">
                    <div @click="openEvaList=!openEvaList" class="title-b">
                        <div>{{ openEvaList ? '展开' : '收起' }}好评案例</div>
                        <img class="whote-icon" :src="require('@/assets/images/ant/whote-down.png')" alt="">
                    </div>
                    <caseItem @showMore="toCaseDetail" class="card-content" :itemInfo="item" :home="true"></caseItem>
                </div>
            </div>
        </transition>

        <iframe v-if="citySelectShow" id="mapPage" width="100%" height="100%" frameborder=0 src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&policy=1&key=UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5&referer=aosms">
        </iframe>


        <awesome-picker ref="popupPicker" :anchor="arrProvince" :data="arrProvinceVlue" colorConfirm="#576b95" colorCancel="#969799"
             swipeTime:500 @cancel="popupCancel" @confirm="popupConfirm" v-if="isAddress"></awesome-picker>
         <div class="info-all" v-if="isPopup">
             <div class="info-box">
                 <div class="popup_top"><img src="@/assets/images/user/popup/popup_top.png" /></div>
                 <!-- 姓名 -->
                 <div class="name-box">
                     <div class="name-title">姓名：</div>
                     <input class="name-input" v-model="name" placeholder="请输入姓名" onfocus="this.placeholder=''" onblur="this.placeholder='请输入姓名'"/>
                 </div>
                 <!-- 电话 -->
                 <div class="name-box">
                     <div class="name-title">电话：</div>
                     <input class="name-input" v-model="phone" placeholder="请输入电话" maxlength="11" type="number" pattern="\d*" onfocus="this.placeholder=''" onblur="this.placeholder='请输入电话'"/>
                 </div>
                 <div class="address-title">地址:</div>
                 <!-- 省市区 -->
                 <div class="address-box" @click="changeAddess">
                     <div class="province">{{popupProvince}}{{popupProvince?'':'省'}}</div>
                     <div class="province">{{popupCity}}{{popupCity?'':'市'}}</div>
                     <div class="province">{{popupDistrict}}{{popupDistrict?'':'区'}}</div>
                 </div>
                 <!-- 详细地址 -->
                 <div class="address-detail">
                     <input class="address-input" v-model="popurAddress" placeholder="请输入您的详细地址" onfocus="this.placeholder=''" onblur="this.placeholder='请输入您的详细地址'"/>
                 </div>
                 <div class="category-box">
                     <div class="category">品类</div>
                     <div class="category-tips">（品类可多选）</div>
                 </div>
                 <div class="button-box">
                     <div :class="item.state == 0?'cate-button':'cate-button-item'"
                         v-for="(item,index) in arrPuporCategory" @click="changeCate(item)">
                         <div>{{item.title}}</div>
                     </div>
                 </div>
                 <div class="signUp" @click="getPush">
                     立即报名
                 </div>
                 <!-- <div class="tips-box">
                     <div class="tips-title">报名有礼：「美容软水沐浴体验装」</div>
                     <div class="tips-content">深层清洁 强效保湿 滋养发丝</div>
                     <div class="tips-litter">注：安装在花洒下，体验装内附说明书，因纸字版说明书里的二维码已过期，如有需求可咨询官方商城客服。</div>
                 </div> -->
             </div>
             <div class="close-icon" @click="changePopur">
                 <img class="close-icon-image" src="@/assets/images/user/popup/close_icon.png" />
             </div>
         </div>
    </div>
</template>
<script>
import MapLoader from "@/libs/AMap.js";
import caseList from "@/components/case-list/v2/index";
import caseItem from "@/components/caseItem/index";
import path from "@/path";
import PullTo from "vue-pull-to";
import { requestAesPost5 } from "@/libsV2/requestAes";
import { getWxSingleConfig, wxGetLocationH5 } from "@/js/wx.js";
export default {
    components: {
        PullTo,
        caseList,
        caseItem,
    },
    data() {
        return {
            isEmpty: false,
            // 好评案例展开状态
            openEvaList: false,
            allCategory: false, // 是否选择所有品类
            objList: {}, //省市id
            anchor: [
                {
                    index: 0,
                    value: "",
                },
                {
                    index: 0,
                    value: "",
                },
            ], //默认选中
            sColor: "#2395ff", //picker取消确定按钮颜色
            arrAnchor: [], //初始化默认值
            address: [], //地级联动列表
            addressData: [], //未解析的地级联动列表
            addressObj: {
                province: "",
                city: "",
                area_id: "",
            },
            bPicker: false,
            isMapShow: true,
            isSearchShow: false, // 搜索显示
            isCaseListShow: false, // 案例列表显示
            domeCity: "",
            sCity: "",
            sProvince: "",
            // 121.492901,31.22506
            nLatitude: 0,
            nLongitude: 0,
            nAldSource:'',

            arrAreaList: [],
            arrCaseList: [],

            bShow: false,
            // 搜索配置文件
            rqname: "", //小区名字搜索
            proType: "",
            searchConf: {
                house_area: [],
                cate: [],
                topic_type: [],
            },
            tab: "",
            sort: {
                time_desc: 0,
                time_asc: 0,
                shares: 0,
                collect_num: 0,
            },
            userinfo: {}, //用户信息

            bSearch: false, // 是否为搜索模式
            allCase: false,

            // 地图
            map: {},
            arrMarkers: [], //标记点
            nActiveIndex: null,
            nName: "",
            cCityId: 0,
            // groupType: "community",
            objTran: {}, //城市数据
            // 好评案例容器显示
            wellEvaVisible: true,
            wellEvaCaseList: [],
            // // 位置选择显示
            citySelectShow: false,
            arrGoods: [], //产品类型
            proTypePage: 0, //产品分页
            isShowSelectType: false, //是否展示产品型号选择框
            isFinish: false, //是否加载完产品所有数据
            isLoading: false, //产品类型加载更多loading

            isPopup: false, //显示弹窗
            isAddress: false, //三级地址选择
            arrPuporCategory: [{
                    id: 1,
                    title: '热水器',
                    state: 0
                },
                {
                    id: 2,
                    title: '烟机',
                    state: 0
                },
                {
                    id: 3,
                    title: '净水机',
                    state: 0
                },
                {
                    id: 4,
                    title: '冷暖风水',
                    state: 0
                },
                {
                    id: 5,
                    title: '其它',
                    state: 0
                },
            ],
            name: '',
            phone: '',
            popupProvince: '',
            popupCity: '',
            popupDistrict: '',
            popurAddress: '',
            type: [],
            arrProvince: [],
            arrProvinceVlue:[]
        };
    },
    async created() {
        this.$store.commit("loadSwitch", true);
        this.sCity = this.$storage.getStorage('objLocation')?.city;
        this.sProvince = this.$storage.getStorage('objLocation')?.province;
        this.nLatitude = this.$storage.getStorage('objLocation')?.lat;
        this.nLongitude = this.$storage.getStorage('objLocation')?.lng;
        this.nAldSource = this.$route.query.ald_source;
        this.wxShare();
        this.initPage();
    },
    mounted() {
        this.$nextTick(() => {
            this.getTree()
            // 百度数据统计
            // _hmt.push(['_trackPageview', '/case/map/v2/lists']);
        });
    },
    methods: {
        //确定
        popupConfirm: function(e)  {
            console.log(e)
            this.popupProvince = e[0].value
            this.popupCity = e[1].value
            this.popupDistrict = e[2].value
            console.log(this.popupProvince)
            console.log(this.popupCity)
            console.log(this.popupDistrict)
            this.isAddress = false
        },
        //取消
        popupCancel() {
            this.isAddress = false
        },
        //地址弹窗选项显示
        changeAddess() {
            this.isAddress = true;
            setTimeout(() => {
                this.$refs.popupPicker.show();
            }, 200);
        },
        //关闭弹窗
        changePopur() {
            this.isPopup = false
        },
        //点击品类多选
        changeCate(item) {
            item.state = item.state ? 0 : 1
            let arrType = []
            this.arrPuporCategory.forEach(it => {
                if (it.state) {
                    arrType.push(it.title)
                }
            })
            console.log(arrType)
            this.type = arrType
        },
        //立即报名，数据上传接口
        getPush() {
            if(this.name==''){
                this.$toast("请输入姓名", {
                    duration: 1500,
                });
                return
            }
            if(this.phone==''){
                this.$toast("请输入电话", {
                    duration: 1500,
                });
                return
            }
            if(this.popupProvince==''||this.popupCity==''||this.popupDistrict==''){
                this.$toast("请选择省市区", {
                    duration: 1500,
                });
                return
            }
            if(this.type == ''){
                this.$toast("请选择品类", {
                    duration: 1500,
                });
                return
            }
            requestAesPost5("topic/free/push",{
                name: this.name,
                phone: this.phone,
                province: this.popupProvince,
                city: this.popupCity,
                district: this.popupDistrict,
                address: this.popurAddress,
                type: JSON.stringify(this.type.join(',')),
                resource: this.nAldSource,
            }).then((res) => {
                console.log(res, 'push.res')
                this.$toast({
                    message: res.data.data.result,
                    // position: "bottom",
                    duration: 1200,
                });
                this.isPopup = false
            })
        },
        // 获取地址三级联动数据
        getTree() {
            requestAesPost5("comm/district/gettree").then((res) => {
                let arrTree = res.data.data.result;
                let arrProvince = arrTree[0];
                let arrAddress = [];
                arrProvince.forEach((it) => {
                    let children = [];
                    arrTree[it.id].forEach(is=>{
                        let minChildren = [];
                        if(arrTree[is.id]?.length && is.id != 0){
                            arrTree[is.id].forEach(ia=>{
                                if(ia.id != 0){
                                    minChildren.push({value:ia.name,id:ia.id})
                                }
                            })
                        }
                        children.push({value:is.name,id:is.id,children:minChildren})
                    })
                    arrAddress.push({value:it.name,id:it.id,children:children})
                });
                this.arrProvinceVlue = arrAddress;
            });
        },


        wxShare() {
            let confit = {
                share_friend_title: `A.O.史密斯口碑地图`,
                share_friend_desc: "云串门平台",
                // share_img_url:
                //     "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                share_link: window.location.href,
            };
            getWxSingleConfig(confit);
        },
        toSpecial() {
            this.$common.redirect("/case/map/v2/special");
        },
        // 上拉加载更多
        onLoadType() {
            if (this.arrGoods.length >= 20) {
                this.proTypePage++;
                this.getGoods();
            }
        },
        // 选择产品型号
        selectGoodName(name) {
            this.proType = name;
        },
        // 监听产品型号input输入
        inputChange() {
            this.isFinish = false;
            this.proTypePage = 0;
            this.arrGoods = [];
            this.getGoods();
        },
        // 产品型号input框聚焦
        focusing() {
            this.isShowSelectType = true;
        },
        blue() {
            this.isShowSelectType = false;
        },
        // 获取产品型号
        getGoods() {
            this.isLoading = true;
            requestAesPost5("topic/aes/searchGoods", {
                word: this.proType ? this.proType : "",
                page: this.proTypePage,
                limit: 20,
            }).then((res) => {
                this.isLoading = false;
                if (res.data.error == 0) {
                    if (
                        this.proTypePage != 0 &&
                        res.data.data.result.length < 20
                    ) {
                        this.isFinish = true;
                        return false;
                    }
                    let arr = this.arrGoods.concat(res.data.data.result);
                    this.arrGoods = arr;
                    console.log(this.arrGoods);
                }
            });
        },

        async initPage(location = true) {
            // if (!this.positionTip()) return;

            this.getCityIdByName().then(() => {
                this.getEvaluateList();
                this.initMap();
            });

            requestAesPost5(path.TOPIC_AES_GET_CONF).then((res) => {
                if (res.data.error == 0) {
                    for (let key in res.data.data.result) {
                        let item = res.data.data.result[key];
                        for (let subitem of item) {
                            subitem.select = false;
                        }
                    }
                    res.data.data.result.cate.forEach((it) => {
                        it.type = 0;
                    });
                    res.data.data.result.brand.forEach((it) => {
                        it.type = 2;
                        // res.data.data.result.tab.push(it)
                    });
                    res.data.data.result.tab.forEach((it) => {
                        it.type = 1;
                        res.data.data.result.cate.push(it);
                    });
                    this.searchConf = res.data.data.result;
                } else {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.msg,
                        position: "bottom",
                        duration: 1200,
                    });
                }
            });
        },

        // 获取城市id
        getCityIdByName() {
            return new Promise((rus) => {
                let _that = this;
                requestAesPost5(path.TOOL_AES_INDEX, {
                    user_id: this.$route.query.tp5Userid,
                    cityName: this.sCity,
                    provinceName: this.sProvince,
                }).then((res) => {
                    _that.objTran = res.data.data.result;
                    rus();
                });
            });
        },
        positionTip() {
            const can = !!this.nLatitude && !!this.nLongitude;
            !can &&
                this.$toast("定位失败，请获取位置信息后重新进入", {
                    duration: 2000,
                });
            return can;
        },
        initMap() {
            let that = this;
            MapLoader().then((AMap) => {
                that.$store.commit("loadSwitch", true);
                // console.log(2)
                let map = new AMap.Map("container", {
                    center: [this.nLongitude, this.nLatitude],
                    expandZoomRange: true,
                    zoom: 15,
                    zooms: [10, 20],
                    showIndoorMap: false, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                    resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                    dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                    keyboardEnable: false, //地图是否可通过键盘控制，默认为true
                    doubleClickZoom: false, // 地图是否可通过双击鼠标放大地图，默认为true
                    zoomEnable: true, //地图是否可缩放，默认值为true
                    rotateEnable: false, // 地图是否可旋转，3D视图默认为true，2D视图默认false
                    scrollWheel: true,
                });
                that.map = map;
                if (map) {
                    map.on("complete", function () {
                        // console.log("地图加载完成！");
                        that.$store.commit("loadSwitch", false);
                        that.logMapBounds().then((res) => {
                            that.getAreaListV5(res, false);
                        });
                    });
                }

                // 地图移动结束
                map.on("moveend", function () {
                    that.wellEvaVisible = false;
                    if (!that.isMapShow) {
                        return false;
                    }
                    that.dataSeash().then((rust) => {
                        that.$store.commit("loadSwitch", true);
                        // console.log(3)
                        that.logMapBounds().then((res) => {
                            if (that.arrMarkers.length) {
                                map.remove(that.arrMarkers);
                            }
                            let data = Object.assign(res, rust);
                            that.getAreaListV5(data, false);
                        });
                    });
                });
                (e) => {
                    console.log("地图加载失败", e);
                };
            });
        },

        toCaseDetail({ id, isnew: isNew }) {
            this.$common.redirect("/case/map/v2/details", {
                city: this.sCity,
                province: this.sProvince,
                latitude: this.nLatitude,
                longitude: this.nLongitude,
                topicid: id,
            });
        },

        // 获取屏幕可视距离标记点
        logMapBounds() {
            return new Promise((resolve, reject) => {
                const bounds = this.map.getBounds();
                // const zoom = this.map.getZoom();
                let northeast = bounds.northeast.toString().split(",");
                let southwest = bounds.southwest.toString().split(",");

                // const groupNum = (20 - zoom) * 90;
                // groupNum >= 0 && (this.groupType = `community`);
                // groupNum >= 500 && (this.groupType = `district`);
                // groupNum >= 2000 && (this.groupType = `city`);
                // groupNum >= 10000 && (this.groupType = `province`);

                let obj = {
                    max_longitude: northeast[0],
                    max_latitude: northeast[1],
                    min_longitude: southwest[0],
                    min_latitude: southwest[1],
                    city_id: this.objTran.city,
                    // groupType: this.groupType,
                    source: "xcx",
                };
                resolve(obj);
            });
        },
        selectAllCategory() {
            this.allCategory = !this.allCategory;
            this.searchConf.cate.forEach((item) => (item.select = false));
        },
        // 冷暖风水
        toAntMap() {
            wx.miniProgram.redirectTo({ url: "/pages/ant_map/index/index" });
        },
        // 商用净水
        toCommercial() {
            wx.miniProgram.redirectTo({ url: "/pages/business/map/index" });
        },
        selectAllCase() {
            if (this.allCase) {
                for (let item of this.searchConf.topic_type) {
                    item.select = false;
                }
            } else {
                for (let item of this.searchConf.topic_type) {
                    item.select = true;
                }
            }
            this.allCase = !this.allCase;
        },

        //picker点击取消
        handlePickerCancel: function () {
            let that = this;
            if (that.bCancel) {
                that.bCancel = false;
                that.anchor = that.arrSelect;
            } else {
                that.bCancel = false;
                // that.anchor = that.anchor;
            }

            this.bPicker = false;
        },
        handlePickerConfirm(e) {
            //console.log("确定", e);
            let that = this;
            that.caseList = [];
            that.page = 0;
            let select = e;
            that.arrSelect = select;
            let addressData = that.addressData;
            let objprovinces = addressData[0].find((item) => {
                return item.name.indexOf(select[0].value.slice(0, 2)) > -1;
            });
            // //console.log("-->省", objprovinces);
            if (objprovinces) {
                let objCity = addressData[objprovinces.id].find((item) => {
                    // //console.log('=>provincestest',item.name.indexOf(province.slice(0,2)))
                    return item.name.indexOf(select[1].value.slice(0, 2)) > -1;
                });
                let provinceId = objprovinces.id;
                let cityId = objCity.id;
                let province = objprovinces.name;
                let city = objCity.name;
                let obj = {};
                obj.city_id = cityId;
                obj.province_id = provinceId;
                that.objList = obj;
                that.bCancel = true;
                that.city = city;
                that.getseash();
            }
        },
        fastSearch(index, item) {
            if (item.type == 1) {
                // 设置当前选中项

                this.searchConf.tab = this.searchConf.tab.map((i, tInd) => {
                    // i.select = index === tInd ? !i.select : i.select;
                    i.select = index === tInd ? !i.select : false;
                    return i;
                });
                this.searchConf.brand = this.searchConf.brand.map((i, tInd) => {
                    i.select = false;
                    return i;
                });

                const active = this.searchConf.cate.findIndex(
                    (item) => item.code == this.searchConf.tab[index].code
                );
                // console.log(this.searchConf.cate);
                // 设置 cate 中的选中项
                if (~active) {
                    this.searchConf.cate[active].select =
                        this.searchConf.tab[index].select;
                }
                // 去除不限的选中项
                this.searchConf["cate"].forEach((it, nIt) => {
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
            } else if (item.type == 2) {
                this.searchConf.brand = this.searchConf.brand.map((i, tInd) => {
                    // i.select = index === tInd ? !i.select : i.select;
                    i.select = index === tInd ? !i.select : false;
                    return i;
                });
                this.searchConf.tab = this.searchConf.tab.map((i, tInd) => {
                    i.select = false;
                    return i;
                });

                const active = this.searchConf.cate.findIndex(
                    (item) => item.code == this.searchConf.brand[index].code
                );
                // 设置 cate 中的选中项
                if (~active) {
                    this.searchConf.cate[active].select =
                        this.searchConf.brand[index].select;
                }
                // 去除不限的选中项
                this.searchConf["brand"].forEach((it, nIt) => {
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
            }
            this.getseash();
        },
        setSearchConfKey(key, index) {
            if (key == "cate" && this.searchConf[key][index].code == 0) {
                if (this.searchConf[key][index].select) {
                    this.searchConf[key].forEach((it, nIt) => {
                        if (it.code != 0) {
                            it.select = false;
                        }
                    });
                } else {
                    this.searchConf[key].forEach((it, nIt) => {
                        if (it.code != 0) {
                            it.select = true;
                        }
                    });
                }
                this.searchConf[key][index].select =
                    !this.searchConf[key][index].select;
            } else {
                this.searchConf[key].forEach((it, nIt) => {
                    // console.log(it);
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
                this.searchConf[key][index].select =
                    !this.searchConf[key][index].select;
            }
        },
        //点击搜索案例初始化
        getShow: function () {
            this.bShow = !this.bShow;
        },
        //跳转附近案例
        gocasemap() {
            this.$common.redirect("/case/map/v2/lists");
        },
        // 百度统计跳转链接
        getClickWindom(type) {
            switch (type) {
                case 1:
                    let source = 'shop_h5list';
                    if(this.$route.query.ald_source){
                        source = 'shop_'+ this.$route.query.ald_source;
                    }
                    _hmt.push(['_trackEvent', source, source, source]);
                    window.location.href =
                        'https://shop.m.jd.com/?shopId=1000001098'
                    break;
                case 2:
                    this.isPopup = true
                    break;
            }
        },
        closeCaseList() {
            this.isCaseListShow = false;
        },
        showCaseList(e) {
            this.isCaseListShow = false;
            this.getCaseList(e.id);
        },
        //二级联动
        show() {
            this.bPicker = true;
            setTimeout(() => {
                this.$refs.picker.show();
            }, 100);
        },
        // 重新定位
        reposition() {
            this.map.setCenter([this.nLongitude, this.nLatitude]);
            // this.isMapShow = false;
            // this.nLatitude = this.$route.query.latitude || "";
            // this.nLongitude = this.$route.query.longitude || "";
            // this.getAreaList();
        },
        // 获取小区位置
        getAreaListV5(res, caseList = true) {
            this.$store.commit("loadSwitch", true);
            // console.log(4)
            requestAesPost5(path.TOPIC_AES_SEARCH_PLOTS_V5_AES, res).then(
                (res) => {
                    // console.log(res)
                    this.arrAreaList = res.data.data.result.list.filter(
                        (_) => _.topic_total !== 0
                    );
                    if (this.arrAreaList.length !== 0) {
                        this.createMarker(this.arrAreaList);
                        this.isEmpty = false;
                        // 获取案例
                        caseList &&
                            setTimeout(() => {
                                this.getCaseList(this.arrAreaList[0].id);
                            }, 500);
                    } else {
                        this.arrCaseList = [];
                        this.$store.commit("loadSwitch", false);
                        this.$toast("该位置附近无案例小区~");
                        this.isEmpty = true;
                        this.isCaseListShow = true;
                    }
                    this.bSearch = false;
                }
            );
            //     .catch((err)=>{
            //     this.$store.commit("loadSwitch", false);
            //     console.log(err)
            // })
        },
        /**
         * 获取好评案例
         */
        getEvaluateList() {
            requestAesPost5(path.TOPIC_COMMENT_TOPICS_AES, {
                latitude: this.nLatitude,
                longitude: this.nLongitude,
                city_id: this.objTran.city,
                province_id: this.objTran.province,
            }).then((res) => {
                const {
                    data: {
                        data: { result },
                    },
                } = res;
                this.wellEvaCaseList = result.map((i) => {
                    const list = i.title.split("-").filter((i) => i !== "m²");
                    i.title_n = list[0] + "-" + list[1];
                    // i.tagsArr = list.filter((i, index) => index >= 2 && i).map(i => i.split(',')).flat().filter(i => i).map((i, ind) => ({
                    //     id: ind,
                    //     type_name: i
                    // }))
                    let tagsArr = [];
                    tagsArr[0] = { id: 0, type_name: i.house_area + "㎡" };
                    i.scence.forEach((it) => {
                        if (it.device_info.length) {
                            it.device_info.forEach((itx, index) => {
                                tagsArr.push(itx);
                            });
                        }
                    });
                    for (let i = 0; i < tagsArr.length; i++) {
                        for (let j = i + 1; j < tagsArr.length; ) {
                            if (tagsArr[i].id === tagsArr[j].id) {
                                //通过属性进行匹配；
                                tagsArr.splice(j, 1); //去除重复的对象；
                            } else {
                                j++;
                            }
                        }
                    }
                    i.tagsArr = tagsArr;
                    i.imgArr = [];

                    if (i.scence.length) {
                        i.scence.forEach((it) => {
                            if (i.imgArr.length < 3) {
                                if (it.house_img.length) {
                                    i.imgArr.push(it.house_img[0]);
                                }
                            }
                        });
                    }

                    return i;
                });
                console.log(this.wellEvaCaseList, "11");
            });
        },
        // 创建标注
        createMarker() {
            const that = this;
            const markers = [];
            //自定义聚合的样式
            const _renderMarker = function (item) {
                let content;
                if (item.total >= 10000) {
                    content =
                        '<div class="ant-map-marker-five-big_v2">' +
                        '<div class="text-five-big">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total >= 1000) {
                    content =
                        '<div class="ant-map-marker-four-big_v2">' +
                        '<div class="text-four-big">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total >= 100) {
                    content =
                        '<div class="ant-map-marker-big_v2">' +
                        '<div class="text-big">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total >= 10) {
                    content =
                        '<div class="ant-map-marker-red-sm_v2">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total < 10) {
                    content =
                        '<div class="ant-map-marker-blue_v2">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                }
                return content;
            };

            const arrMarker = this.arrAreaList.map((item, index) => {
                let markerContent = _renderMarker(item);
                let markerOnContent =
                    '<div class="ant-map-marker-yellow">' +
                    '<div class="text">' +
                    item.total +
                    "</div>" +
                    "</div>";
                const marker = new AMap.Marker({
                    zIndex: index + 1,
                    position: new AMap.LngLat(
                        Number(item.longitude),
                        Number(item.latitude)
                    ),
                    content: markerContent,
                    extData: {
                        id: index,
                        name: item.total,
                    },
                    offset: new AMap.Pixel(-13, -30),

                    animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
                });
                // 绑定点击事件
                marker.on("click", function ({ lat, lng, type, target }) {
                    that.map.setZoom(15);
                    const zoomNow = that.map.getZoom();
                    // if (that.groupType === "community") {
                    that.$store.commit("loadSwitch", true);
                    // console.log(5)
                    if (that.nActiveIndex !== null) {
                        that.arrMarkers[that.nActiveIndex].setContent(
                            '<div class="ant-map-marker-blue">' +
                                '<div class="text">' +
                                that.nName +
                                "</div>" +
                                "</div>"
                        );
                        // }
                        // 设置当前标注颜色
                        target.setContent(markerOnContent);
                        // // 记住当前索引
                        that.nActiveIndex = target.getExtData().id;
                        that.nName = target.getExtData().name;
                        // 传递参数父组件
                        that.showCaseList({ ...item });
                    } else {
                        that.map.setZoomAndCenter(
                            zoomNow < 14 ? zoomNow + 1 : zoomNow + 2,
                            new AMap.LngLat(
                                Number(item.longitude),
                                Number(item.latitude)
                            )
                        );
                        that.showCaseList({ ...item });
                    }
                });
                return marker;
            });
            let markerContentNow =
                '<div class="ant-map-marker">' +
                '<img src="' +
                require("@/assets/images/icon_yellow.png") +
                '">' +
                "</div>";
            let markerNow = new AMap.Marker({
                position: new AMap.LngLat(this.nLongitude, this.nLatitude),
                content: markerContentNow,
                offset: new AMap.Pixel(-13, -30),
                animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
            });
            arrMarker.push(markerNow);
            this.arrMarkers = arrMarker;
            this.map.add(arrMarker);
            that.$store.commit("loadSwitch", false);
        },
        // 获取搜索参数
        dataSeash() {
            return new Promise((res, error) => {
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    // 选中的访问面积
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");

                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    // 判断品类中的不限是否选中，选中会被添加到数组中
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    // 如果选中了品类中的不限
                    arr.push(0);
                } else {
                    // 未选中品类中的不限
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(","); // 选中的品类
                arr = [];
                for (let item of this.searchConf.topic_type) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let type = arr.join(",");
                arr = [];
                for (let item of this.searchConf.brand) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let brand_id = arr.join(",");
                let data = {
                    user_id: this.$route.query.userid,
                    search_keys: this.rqname,
                    page: 1,
                    limit: 20,
                    parent_id: parent_id,
                    model: this.proType,
                    type: type,
                    area: area,
                    brand_id: brand_id,
                };
                res(data);
            });
        },
        // 搜索缩小屏幕
        setZoom() {
            let that = this;
            return new Promise((res) => {
                that.map.setZoom(10);
                res();
            });
        },
        // 搜索获取案例
        async getseash(from = false) {
            let that = this;
            that.wellEvaVisible = false;
            that.isMapShow = false;
            that.setZoom().then((res) => {
                setTimeout(() => {
                    that.dataSeash().then((rust) => {
                        that.logMapBounds().then((res) => {
                            if (that.arrMarkers.length) {
                                that.map.remove(that.arrMarkers);
                            }
                            that.isMapShow = true;
                            let data = Object.assign(res, rust);
                            that.getAreaListV5(data);
                        });
                        that.bShow = false;
                        that.bSearch = true;
                    });
                }, 500);
            });
        },

        // 获取案例
        getCaseList(id) {
            // if (this.groupType !== "community") return;
            this.dataCaseList(id).then((reult) => {
                requestAesPost5(path.TOPIC_AES_TOPIC_BY_PLOTS, reult).then(
                    (res) => {
                        let resultData = res;
                        this.arrCaseList = resultData.data.data.result.lists;
                        this.$store.commit("loadSwitch", false);
                        this.isCaseListShow = true;
                        // 关闭好评案例
                        this.wellEvaVisible &= false;
                    }
                );
            });
        },
        // 获取案例参数
        dataCaseList(id) {
            return new Promise((res, error) => {
                this.isCaseListShow = false;
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");

                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    arr.push(0);
                } else {
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(",");

                arr = [];
                for (let item of this.searchConf.topic_type) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let type = arr.join(",");
                const requestData = {
                    plot_id: id,
                    source: "xcx",
                    search_keys: this.rqname,
                    parent_id: parent_id,
                    model: this.proType,
                    type: type,
                    area: area,
                };
                res(requestData);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.case-map {
    width: 100%;
    height: 100vh;
}

#mapPage {
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    position: fixed;
    left: 0;
    bottom: 0;
}

@import "../../index";
@import "index";
</style>
